//some images have load later so you need the image load event to catch them
//some images load immediately before the load event is even set so you must call the method anyway to catch them

export default (function () {
    const init = () => {     
       
        const figures = document.querySelectorAll(".lots-row figure");

        const figureCount = figures.length;

        if (figureCount < 1) {
            return;
        }

        let image;

        for (let i = 0; i < figureCount; i++) {
            image = figures[i].querySelector("img");
            addResizeStylesIfNeeded(figures[i]);
            image.addEventListener('load', () => {
                addResizeStylesIfNeeded(figures[i]);
            });          
        }     
    };

    const addResizeStylesIfNeeded = (figure) => { 
        const image = figure.querySelector("img");
        const figureHeight = figure.offsetHeight;
        const imageHeight = image.offsetHeight;

        if (imageHeight > 0 && imageHeight < figureHeight) {
            image.style.width = "auto";
            image.style.height = "100%";
        }
    };

    return {
        init: init
    };
})();


